module.exports = __webpack_public_path__ + "5026096605c51347192ecd70bed3b9cf.svg";